// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"199":"4f2f7375d533aca59864","225":"4b69d3e9b4f0dc604a36","357":"a7fff48061165663a4f1","585":"e3bfa970f4f1904413bc","666":"fb57354191ab3abedbfb","837":"faf8b9e6f2b9cda4a9ca","955":"2801c6a7b096a32b666a"}[chunkId] + ".bundle.js";
};